var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"livehead text-center",staticStyle:{"height":"50px"},style:({ 'background-color': _vm.$store.getters.setting.bgColor })},[_c('div',[_vm._t("header")],2)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }